import { Component, Input } from '@angular/core';

@Component({
  selector: 'adc-progressindicator',
  templateUrl: './adc-progressindicator.component.html',
  styleUrls: ['./adc-progressindicator.component.scss'],
  standalone: false
})
export class AdcProgressindicatorComponent {
  @Input('type') type: string = 'basic';
  @Input('data') data: any;
  progressValue: number = 0;
  step1Completed: boolean = true;
  step2Completed: boolean = false;
  step3Completed: boolean = true;
  step4Completed: boolean = true;
  step5Completed: boolean = false;

  changeProgress(move: string) {
    if(move == 'prev') {
      if(this.data.progress > 0 && this.data.progress <= 25) {
        this.data.progress = 0;
      } else if(this.data.progress > 25 && this.data.progress <= 50) {
        this.data.progress = 25;
      } else if(this.data.progress > 50 && this.data.progress <= 75) {
        this.data.progress = 50;
      } else if(this.data.progress > 75 && this.data.progress <= 100) {
        this.data.progress = 75;
      }
    } else {
      if(this.data.progress >= 0 && this.data.progress < 25) {
        this.data.progress = 25;
      } else if(this.data.progress >= 25 && this.data.progress < 50) {
        this.data.progress = 50;
      } else if(this.data.progress >= 50 && this.data.progress < 75) {
        this.data.progress = 75;
      } else if(this.data.progress >= 75 && this.data.progress < 100) {
        this.data.progress = 100;
      }
    }
  }
}
